import React, {useMemo} from "react";
import {useTranslation} from "react-i18next";
import {PurchaseHistorySingleLogsDataGridCellKeys} from "../../../../../../../../../core/constants/table/data-grid-column-keys";
import {
    DataGridColumnAlignments,
    DataGridColumnTypes,
    useDataGridSavedState,
} from "../../../../../../../../../packages/data-grid";
import PartnerDataGrid from "../../../../../../../../containers/data-grid";
import DateUtils from "../../../../../../../../../core/services/date-utils";

const saveConfig = {name: 'PurchaseHistorySingleLogsDataGrid', version: 1};

/**
 * Formats a log timestamp for the activity grid.
 */
const formatLoggedAt = (value) => {
    if (!value) {
        return '';
    }
    return DateUtils.serverToLocal(value).format(DateUtils.dateTimeFormat);
};

/**
 * Activity / audit logs tab for purchase history single (shell rows until API exists).
 */
const PurchaseHistorySingleLogsSection = ({logs = [], loading = false}) => {
    const {t} = useTranslation('views', {keyPrefix: 'app-specific.purchases.historySingle.logs'});

    const columns = useMemo(() => /** @type {DataGridColumn[]} */ ([
        {
            title: t('columns.loggedAt'),
            name: PurchaseHistorySingleLogsDataGridCellKeys.loggedAt,
            type: DataGridColumnTypes.string,
            alignment: DataGridColumnAlignments.left,
            width: 180,
        },
        {
            title: t('columns.user'),
            name: PurchaseHistorySingleLogsDataGridCellKeys.user,
            type: DataGridColumnTypes.string,
            alignment: DataGridColumnAlignments.left,
        },
        {
            title: t('columns.action'),
            name: PurchaseHistorySingleLogsDataGridCellKeys.action,
            type: DataGridColumnTypes.string,
            alignment: DataGridColumnAlignments.left,
        },
        {
            title: t('columns.details'),
            name: PurchaseHistorySingleLogsDataGridCellKeys.details,
            type: DataGridColumnTypes.string,
            alignment: DataGridColumnAlignments.left,
            width: 280,
        },
    ]), [t]);

    const [gridColumns, , , density] = useDataGridSavedState({columns, ...saveConfig});

    const rows = useMemo(() => logs.map((log) => ({
        key: log.id,
        data: log,
        cells: {
            [PurchaseHistorySingleLogsDataGridCellKeys.loggedAt]: formatLoggedAt(log.loggedAt),
            [PurchaseHistorySingleLogsDataGridCellKeys.user]: log.user,
            [PurchaseHistorySingleLogsDataGridCellKeys.action]: log.action,
            [PurchaseHistorySingleLogsDataGridCellKeys.details]: log.details,
        },
    })), [logs]);

    return (
        <PartnerDataGrid
            {...saveConfig}
            initialLayoutState={{columns}}
            columns={gridColumns}
            rows={rows}
            hideFooterActions
            hideExporting
            state={{loading: {state: loading}, density}}
        />
    );
};

export default PurchaseHistorySingleLogsSection;
